import enums from '../libs/enum'

export default {
    fmtUserRole: value => {
        return enums.UserRole[value] || '未定义'
    },
    fmtUserLevel: value => {
        return enums.UserLevel[value] || '未定义'
    },
    fmtGender: value => {
        return enums.Gender[value] || '未定义'
    },
    fmtCtaLevel: value => {
        return enums.CtaLevel[value] || '未定义'
    },
    fmtUnitService: value => {
        return enums.UnitService[value] || '未定义'
    },
    fmtCertType: value => {
        return enums.CertType[value] || '未定义'
    },
    fmtCertGrade: value => {
        return enums.CertGrade[value] || '未定义'
    },
    fmtCourseType: value => {
        return enums.CourseType[value] || '未定义'
    },
    fmtTeamType: value => {
        return enums.TeamType[value] || '未定义'
    },
    fmtTeamRole: value => {
        return enums.TeamRole[value] || '未定义'
    },
    fmtDays: value => {
        if (isNaN(value)) {
            return '无效日期'
        }
        let val = Number(value)
        if (val <= 0) {
            return '长期有效'
        }
        if (val === 365) {
            return '一年'
        }
        if (val === 730) {
            return '两年'
        }
        if (val === 1825) {
            return '五年'
        }
        if (val === 3650) {
            return '十年'
        }
        return val + '天'
    }
}
